module.exports = __webpack_public_path__ + "static/media/celebration-marker.34a06e82.png";